import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  OrganizationDetail,
  UpdateOrganizationRequest,
} from '@nucleus-commerce/api-client/platform';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

/** PATCH name, billing email and operator notes; merges the answer over the cached detail. */
export function useUpdateOrganization(organizationId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateOrganizationRequest) =>
      organizationsApi.update(organizationId, input),
    meta: { successMessage: 'organizations:toasts.updated' },
    onSuccess: (organization) => {
      queryClient.setQueryData<OrganizationDetail>(
        organizationKeys.detail(organizationId),
        (previous) => (previous ? { ...previous, ...organization } : undefined),
      );
      return queryClient.invalidateQueries({ queryKey: organizationKeys.lists() });
    },
  });
}
